import * as R from 'ramda';
import React, { useEffect, useMemo, useState } from 'react';
import { ListContextProvider } from 'react-admin';
import * as hash from 'hash-sum';

export default (props) => {
  const {
    list,
    uniqueKey,
    defaultSort = { field: '', order: 'ASC' },
    sorters = {},
    nullsLastFields = [],
    children,
  } = props;

  const dataMap = useMemo(() => R.indexBy(R.prop(uniqueKey), list), [
    list,
    uniqueKey,
  ]);

  const [currentSort, setSort] = useState(defaultSort);
  const [sortedKeys, setSortedKeys] = useState(R.pluck(uniqueKey, list));

  const cachedSorters = useMemo(() => R.map(R.memoizeWith(hash), sorters), [
    sorters, //eslint-disable-line
  ]);

  const handleSort = (field, order) => {
    const sorter = R.propOr(R.path(R.split('.', field)), field, cachedSorters);
    const nullsLast = R.includes(field, nullsLastFields);

    const sorted = nullsLast
      ? R.sort((a, b) => {
          const aVal = sorter(a);
          const bVal = sorter(b);
          const aNull = R.isNil(aVal);
          const bNull = R.isNil(bVal);
          if (aNull && bNull) return 0;
          if (aNull) return 1;
          if (bNull) return -1;
          const cmp = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
          return order === 'DESC' ? -cmp : cmp;
        }, list)
      : R.sortBy(sorter, list);

    setSortedKeys(
      R.pipe(
        R.pluck(uniqueKey),
        R.when(R.always(!nullsLast && R.equals(order, 'DESC')), R.reverse)
      )(sorted)
    );
    setSort({ field, order });
  };

  // Perform initial sort
  useEffect(() => {
    if (!R.isEmpty(defaultSort.field)) {
      handleSort(defaultSort.field, defaultSort.order);
    }
  }, []); //eslint-disable-line

  return (
    <ListContextProvider
      value={{
        basePath: '',
        data: dataMap,
        ids: sortedKeys,
        currentSort: currentSort,
        setSort: handleSort,
        selectedIds: [],
      }}
    >
      {children}
    </ListContextProvider>
  );
};
